import React, { useEffect } from "react";
import "./Solution2.css";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
const EnterpriseSearch = () => {
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  return (
    <>
      <Header />
      <div className="resilience-container">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <div className="backup-container">
              <a href="/solutions#Infrastructure" className="backup-text">
                Solution
              </a>
              <p>/Enterprise Search​</p>
            </div>

            <div className="hero-wrapper">
              <div className="hero-text-container">
                <div className="hero-text-content">
                  <h1 className="hero-title">
                    <span className="hero-title-main">Enterprise Search​</span>
                  </h1>
                  <p className="hero-subtitle">
                    Finding critical information across your vast data silos can
                    be a nightmare. Employees waste time searching for
                    documents, knowledge, and applications, hindering.
                    productivity and decision-making.​
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <div className="introduction-text">
            <b>Introducing Elastic Enterprise Search</b> : Elastic Enterprise
            Search is a powerful search engine built for the modern enterprise.
            It goes beyond traditional search, allowing you to surface relevant
            information from all your data sources, regardless of format or
            location.​
          </div>

          <h2 className="section-title">Benefits​​</h2>
          <div className="boost-productivity-container">
            <p className="boost-productivity-text">
              <b>Boost Productivity</b>: Empower your employees with fast,
              accurate search results. Spend less time searching, more time
              doing.​​
            </p>
            <p className="boost-productivity-text">
              <b>Improved Decision Making</b>: Gain instant access to the data
              you need to make informed business decisions.
            </p>
            <p className="boost-productivity-text">
              <b>Boost Productivity</b>: Empower your employees with fast,
              accurate search results. Spend less time searching, more time
              doing.​​
            </p>
            <p className="boost-productivity-text">
              <b>Enhanced User Experience</b>: Deliver a seamless search
              experience across your entire organization. Find what you need,
              when you need it.​​
            </p>
            <p className="boost-productivity-text">
              <b>Unified Knowledge Base</b>: Consolidate information from
              various sources, including documents, emails, code repositories,
              and applications.​​
            </p>
            <p className="boost-productivity-text">
              <b>Scalability and Flexibility</b>: Elastic Search scales
              effortlessly to accommodate your growing data needs.​​
            </p>
            <p className="boost-productivity-text">
              <b>
                Here's how Elastic Enterprise Search empowers your specific
                roles :
              </b>
            </p>
            <p className="boost-productivity-text">
              <b>IT Managers</b>: Simplify IT operations with centralized search
              management and performance monitoring.​​​
            </p>
            <p className="boost-productivity-text">
              <b>Business Owners</b>: Gain valuable insights from your data to
              drive strategic decision-making.​​
            </p>
            <p className="boost-productivity-text">
              <b>IT Decision Makers </b>: Invest in a future-proof search
              solution that adapts to your evolving needs.​​
            </p>
            <p className="boost-productivity-text">
              <b>
                Ready to unlock the power of information within your
                organization?
              </b>
              :
            </p>
            <p className="boost-productivity-text">
              <b>
                Contact us today for a free consultation and discover how
                Elastic Enterprise Search can transform your business!​
              </b>
              :
            </p>
          </div>

          <br />
          <br />
          <h2 className="highlighted-section-title">
            Additional Information​​​
          </h2>
          <div className="highlighted-introduction-text">
            Consider adding a brief bullet point mentioning Elastic's security
            features, especially if data privacy is a concern for your target
            audience.​ You can incorporate a short video showcasing the user
            interface and search capabilities of Elastic Enterprise Search.​
            Include a link to a case study or customer testimonial demonstrating
            the success of Elastic Search in a similar business environment.​
          </div>
          <br /> <br />
          <div className="software-contact-button-wrapper">
            <a
              href="/contactus?subject=Enterprise%20Search"
              className="software-contact-button"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EnterpriseSearch;
